import api from './api';

const roleService = {
  listRoles: async () => {
    const response = await api.get('/roles');
    return response.data.roles || [];
  },

  assignRole: async ({ userId, roleName }) => {
    const response = await api.post('/roles/assign', { userId, roleName });
    return response.data;
  }
};

export default roleService;
